import { useState } from "react";
import { useChat, fetchServerSentEvents } from "@tanstack/ai-react";
import { TanStackDevtools } from "@tanstack/react-devtools";
import { aiDevtoolsPlugin } from "@tanstack/react-ai-devtools";

export default function App() {
  const [input, setInput] = useState("");

  const chat = useChat({
    connection: fetchServerSentEvents("https://vu-ai-worker.juan-fernandez-496.workers.dev/api/chat"),
  });

  return (
    <>
      <div>
        {chat.messages.map((m: any) => (
          <div key={m.id}>
            <b>{m.role}:</b>{" "}
            { console.log(m) }

            {m.parts?.map((p: any) => {
              if("content" in p) {
                if(p.content.includes('Validation failed:')) {
                  return ''
                } else {
                  return p.content
                }
              } else {
                return ''
              }
            })}
          </div>
        ))}

        <form
          onSubmit={(e) => {
            e.preventDefault();
            const text = input.trim();
            if (!text) return;
            chat.sendMessage(text);
            setInput("");
          }}
        >
          <input value={input} onChange={(e) => setInput(e.target.value)} />
          <button type="submit" disabled={chat.isLoading}>
            Send
          </button>
        </form>
      </div>

      <TanStackDevtools plugins={[aiDevtoolsPlugin()]}
      />
    </>
  );
}
